<template>
  <section id="meme-generator">
    <div
      :style="[{ backgroundImage: 'url(' + memeBGImage + ')' }, {backgroundColor: prismic_data.support_background_color}]"
      class="meme-container"
    >
      <div v-if="!isMemeGenerated" class="container-small">
        <h5>{{prismic_data.support_title[0].text}}</h5>
        <p>{{prismic_data.support_form_intro}}</p>
        <form v-on:submit.prevent="onSubmit">
          <input
            type="text"
            :placeholder="prismic_data.support_form_name_placeholder"
            v-model="name"
            :class="{'error-name': errorName}"
          />
          <div class="form-row">
            <div class="form-group">
              <label :class="{'error-gender': errorGender}">
                <input
                  @click="changeImage"
                  v-model="gender"
                  type="radio"
                  id="male"
                  name="gender"
                  value="male"
                />
                {{prismic_data.form_option_1}}
              </label>
            </div>
            <div class="form-group">
              <label :class="{'error-gender': errorGender}">
                <input
                  @click="changeImage"
                  v-model="gender"
                  type="radio"
                  id="female"
                  name="gender"
                  value="female"
                />
                {{prismic_data.form_option_2}}
              </label>
            </div>
            <div class="form-group">
              <label :class="{'error-gender': errorGender}">
                <input
                  @click="changeImage"
                  type="radio"
                  id="not-specified"
                  name="gender"
                  value="not-specified"
                  v-model="gender"
                />
                {{prismic_data.form_option_3}}
              </label>
            </div>
          </div>
          <button class="button-primary">{{prismic_data.support_button_text}}</button>
        </form>
      </div>

      <div
        v-if="isMemeGenerated"
        class="container-small generated-meme"
        :class="[gender ? 'type-' + gender : 'type-none']"
      >
        <h5>{{prismic_data.support_title[0].text}}</h5>
        <p v-html="story.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
        <div class="share">
          <button
            @click="generateNewMeme"
            class="button-primary button-regenerate"
          >{{prismic_data.support_generate_new_button_text}}</button>
          <a @click="fbShare($event)" href class="social-icon">
            <prismic-image :field="prismic_data.facebook_icon" />
          </a>
          <a
            class="social-icon"
            target="_blank"
            :href="`https://twitter.com/intent/tweet?url=${encodeURIComponent(meme_image)}`"
          >
            <prismic-image :field="prismic_data.twitter_icon" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "MemeGenerator",
  props: {
    prismic_data: {
      type: Object,
      required: true,
    },
    windowSize: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      memeBGImage: String,
      optionSelected: false,
      name: "",
      gender: "",
      meme_image: "",
      isMemeGenerated: false,
      story: "",
      errorName: false,
      errorGender: false,
    };
  },
  created() {
    this.getBackgroundImage;
    window.addEventListener("resize", this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  computed: {
    getBackgroundImage() {
      this.toggleDefaultImage();
      return this.memeBGImage;
    },
  },
  methods: {
    onSubmit() {
      let apiURL = "";
      let choosenGender = this.gender;

      this.errorName = false;
      this.errorGender = false;
      
      //if (process.env.NODE_ENV === "development") {
        apiURL = "https://phpstack-306712-1413303.cloudwaysapps.com";
      //}

      if (
        this.name &&
        this.gender &&
        this.name.length >= 2 &&
        this.name.length <= 30
      ) {
        if (this.gender === "not-specified") {
          choosenGender = "";
        }

        let locale = this.$route.name === "index_en" ? "en" : "ua";

        axios
          .get(
            `${apiURL}/api/public/generate/sasha-and-sasha?gender=${choosenGender}&name=${this.name}&locale=${locale}`
          )
          .then((response) => {
            this.story = response.data.story;
            this.meme_image = response.data.link;
            this.toggleImageGender();
            this.isMemeGenerated = true;
          });
      }

      if (!this.name) {
        this.errorName = true;
      }

      if (!this.gender) {
        this.errorGender = true;
      }
    },
    generateNewMeme() {
      this.isMemeGenerated = false;
      this.toggleDefaultImage();
    },
    fbShare(e) {
      e.preventDefault();
      FB.ui(
        {
          method: "share",
          href: this.meme_image,
        },
        function (response) {}
      );
    },
    changeImage() {
      this.optionSelected = true;
      this.toggleImageSelected();
    },
    toggleDefaultImage() {
      this.memeBGImage =
        this.windowSize > 768
          ? this.prismic_data.support_background_image.url
          : this.prismic_data.support_background_image_mobile.url;
    },
    toggleImageSelected() {
      this.memeBGImage =
        this.windowSize > 768
          ? this.prismic_data.support_background_image_selected.url
          : this.prismic_data.support_background_image_mobile_selected.url;
    },
    toggleImageGender() {
      switch (this.gender) {
        case "male":
          this.memeBGImage =
            this.windowSize > 768
              ? this.prismic_data.support_background_image_male.url
              : this.prismic_data.support_background_image_mobile_male.url;
          break;
        case "female":
          this.memeBGImage =
            this.windowSize > 768
              ? this.prismic_data.support_background_image_female.url
              : this.prismic_data.support_background_image_mobile_female.url;
          break;
        case "not-specified":
          this.memeBGImage =
            this.windowSize > 768
              ? this.prismic_data.support_background_image_not_specified.url
              : this.prismic_data.support_background_image_mobile_not_specified
                  .url;
          break;
        default:
          break;
      }
    },
    toggleImagesResize() {
      if (this.optionSelected) {
        this.toggleImageSelected();
      } else {
        this.toggleDefaultImage();
      }
    },
    resizeHandler(e) {
      this.windowSize = e.target.innerWidth;
      if (this.isMemeGenerated) {
        this.toggleImageGender();
      } else {
        this.toggleImagesResize();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.meme-container {
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
  padding-bottom: 122px;
  padding-top: 80px;
  min-height: 600px;
  @media (max-width: $breakpoint-sm) {
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 50px;
    padding-bottom: 0;
    height: 1020px;
  }

  .container-small {
    width: 500px;
    margin: 0 auto;
    @media (max-width: $breakpoint-sm) {
      width: 100%;
      padding: 0 30px;
    }

    &.generated-meme {
      width: 743px;
      @media (max-width: $breakpoint-sm) {
        width: 100%;
        text-align: center;
      }
      h5 {
        text-align: left;
        @media (max-width: $breakpoint-sm) {
          text-align: center;
        }
      }
      p {
        font-family: $font-secondary;
        font-weight: bold;
        font-size: 32px;
        line-height: 30px;
        color: $font-color-meme;
        text-align: left;
        @media (max-width: $breakpoint-sm) {
          text-align: center;
          font-weight: normal;
          font-size: 24px;
          line-height: 40px;
        }
      }
      &.type-not-specified {
        width: 630px;
        margin: 0 auto;
        text-align: center;
        @media (max-width: $breakpoint-sm) {
          width: 100%;
        }
        h5,
        p {
          text-align: center;
        }
      }
    }
  }

  h5 {
    line-height: 62px;
    color: $color-purple;
    text-transform: uppercase;
    text-align: center;

    @media (max-width: $breakpoint-sm) {
      line-height: 47px;
      padding: 0 10px;
    }
  }

  p {
    text-align: center;
    margin-top: 28px;
    line-height: 32px;
  }
}

.share {
  display: inline-flex;
  align-items: flex-end;
  @media (max-width: $breakpoint-sm) {
    display: inline-block;
  }
  .social-icon {
    margin-right: 28px;
    @media (max-width: $breakpoint-sm) {
      margin-right: 20px;
    }
    &:last-of-type {
      margin-right: 0;
    }
  }
  .button-primary {
    padding: 13px 83px;
    margin-top: 78px;
    margin-right: 40px;
    @media (max-width: $breakpoint-sm) {
      margin: 0 auto;
      margin-bottom: 36px;
      margin-top: 50px;
      padding: 10px 28px;
    }
  }
}

form {
  margin-top: 75px;
  @media (max-width: $breakpoint-sm) {
    text-align: center;
  }
  .form-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: $breakpoint-sm) {
      display: inline-block;
      text-align: left;
    }
    .form-group:not(:last-child) {
      @media (max-width: $breakpoint-sm) {
        margin-bottom: 30px;
      }
    }
  }
  input[type="radio"] {
    margin-right: 8px;
    position: static;
  }
  input[type="text"] {
    width: 100%;
    border-bottom: 1px solid #979797;
    padding-bottom: 6px;
    padding-left: 6px;
    outline: none;
    margin-bottom: 30px;
    &.error-name {
      border-bottom: 1px solid #da1111;
    }
  }

  .button-primary {
    padding: 13px 83px;
    margin: 0 auto;
    margin-top: 78px;
    @media (max-width: $breakpoint-sm) {
      margin-top: 50px;
      padding: 10px 70px;
    }
  }

  .error-gender {
    color: #da1111;
  }
}
</style>